import { render, staticRenderFns } from "./PermissionsFishingPlans.vue?vue&type=template&id=3e68aaa8&scoped=true&"
import script from "./PermissionsFishingPlans.vue?vue&type=script&lang=js&"
export * from "./PermissionsFishingPlans.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsFishingPlans.vue?vue&type=style&index=0&id=3e68aaa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68aaa8",
  null
  
)

export default component.exports